export enum DHLAdditionalServices {
    PreAdviceByDriver = 'preAdviceByDriver',
}



// WEBPACK FOOTER //
// ./src/app/model/additional-services.enum.ts